import ParallaxWaves from "./ParallaxWaves.js";
import React, { useEffect, useState } from "react";
import { useConfigsQuery } from "./components/queries.js";
import SwiperSlider from "./components/SwiperSlider.js";

export default function HeroImage() {
  const { loading, error, data } = useConfigsQuery();
  const [images, setImages] = useState(null);

  useEffect(() => {
    if (data) {
      const banners = data.banners.data;
      const currentDate = new Date();

      // Filter bundles based on start_date and end_date
      const activeBanners = banners.filter((banner) => {
        const startDate = new Date(banner.attributes.start_date);
        const endDate = new Date(banner.attributes.end_date);
        return startDate <= currentDate && endDate >= currentDate;
      });
      updateImageSource(activeBanners);
    }
  }, [data]);

  function updateImageSource(banners) {
    const viewportWidth = window.innerWidth;
    const filteredImages = [];
    banners.forEach((banner) => {
      if (viewportWidth >= 1025) {
        filteredImages.push({
          image: banner.attributes.banner_desktop_1920w.data.attributes.url,
          desc: banner.attributes.description,
          color: banner.attributes.color,
          hasButtons: banner.attributes.download_buttons,
        });
      } else if (viewportWidth >= 620) {
        filteredImages.push({
          image: banner.attributes.banner_tab_780w.data.attributes.url,
          desc: banner.attributes.description,
          color: banner.attributes.color,
          hasButtons: banner.attributes.download_buttons,
        });
      } else {
        filteredImages.push({
          image: banner.attributes.banner_mobile_540w.data[0].attributes.url,
          desc: banner.attributes.description,
          color: banner.attributes.color,
          hasButtons: banner.attributes.download_buttons,
        });
      }
    });
    setImages(filteredImages);
  }

  return (
    <div className="main-image" id="home">
      <div className="image--carousel">
      {loading ? (
            <div className="center">Loading...</div>
          ) : error ? (
            <div>Error: {error.message}</div>
          ) : (images && 
                  <SwiperSlider slides={images} />
            )}
        <ParallaxWaves />
      </div>
    </div>
  );
}
